import React from 'react';

const Loader = (props) => {
  return (
    <div className={props.className}>
      <div className="animate_loader"></div>
    </div>
  );
};

export default Loader;
